const KEY = "star:launch-origin:v1";

/** Fixed context, never an arbitrary URL. New ordinary launches clear old context. */
export function showcaseOrigin(location: Pick<Location, "search" | "pathname" | "origin">, consoleBase: string, storage?: Pick<Storage, "getItem" | "setItem" | "removeItem">): boolean {
  const query = new URLSearchParams(location.search);
  const inConsole = new URL(consoleBase, location.origin).origin === location.origin;
  const center = inConsole && /^\/showcase(?:\/|$)/.test(location.pathname);
  let remembered = false;
  try { remembered = storage?.getItem(KEY) === "showcase"; } catch { /* Storage can be disabled. */ }
  const explicit = query.has("starOrigin") || query.has("handoff") || query.has("consoleLaunch") || query.has("worldLaunch");
  const active = center || (explicit ? query.get("starOrigin") === "showcase" : inConsole ? false : remembered);
  try { if (active) storage?.setItem(KEY, "showcase"); else storage?.removeItem(KEY); } catch { /* URL context still works. */ }
  return active;
}
